// extracted by mini-css-extract-plugin
export var articles = "j_br";
export var articleList = "j_bs";
export var articleWrap = "j_bt";
export var content = "j_bv";
export var des = "j_bw";
export var title = "j_bq";
export var avatar = "j_bx";
export var imgWrap = "j_by";
export var img = "j_bz";